import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: "/",
    name: "join",
    title: "首页",
    component: () => import("../views/future.vue")
  },
  // {
  //   path: "/coopera",
  //   name: "coopera",
  //   title: "合作伙伴",
  //   component: () => import("../views/coopera.vue")
  // },
  // {
  //   path: "/product",
  //   name: "product",
  //   title: "产品中心",
  //   component: () => import("../views/product.vue")
  // },
  // {
  //   path: "/join",
  //   name: "join",
  //   title: "加入我们",
  //   component: () => import("../views/join.vue")
  // },
  // {
  //   path: "/programme",
  //   name: "programme",
  //   title: "解决方案",
  //   component: () => import("../views/programme.vue")
  // },
  // {
  //   path: "/newsCenter",
  //   name: "newsCenter",
  //   title: "新闻中心",
  //   component: () => import("../views/newsCenter.vue")
  // },
  // {
  //   path: "/newsCenterBase",
  //   name: "newsCenterBase",
  //   title: "新闻详情",
  //   component: () => import("../views/newsCenterBase.vue")
  // },
  // {
  //   path: "/fome",
  //   name: "fome",
  //   title: "表单收集",
  //   component: () => import("../views/fome.vue")
  // },
    {
    path: "/join",
    name: "fome",
    title: "表单收集",
    component: () => import("../views/join.vue")
  },
  {
    path: "/future",
    name: "future",
    title: "关于我们",
    component: () => import("../views/future.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js